/** Запрос на проверку корректного пути*/
export class CheckRouteRequestModel {
  /** Айди проекта */
  ProjectId!: number;
  /** Айди НС */
  NamespaceId!: string;
  /** Айди очереди задачи */
  QueueTaskId?: string;
  /** Айди задачи */
  TaskId?: number;
  /**id папки */
  GroupId?: number;
  constructor(obj?: Partial<CheckRouteRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
